import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS,I_COMMON_DELETE_PARAMS} from './_base';

import I_ACTIVITY_TYPE from '../interfaces/I_ACTIVITY_TYPES';
import {
  getActivityTypesResponse,
  postActivityTypeResponse,
  deleteActivityTypeResponse,
  putActivityTypeResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- ACTIVITY TYPES
// ---------------------------------

const logger = LoggerService.getInstance();

/**
 * Récupère la liste des types d'activité
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,dispatch,state}:I_COMMON_GET_ALL_PARAMS):Promise<I_ACTIVITY_TYPE[]> => {
  logger.debug('ApiServices - getActivityTypes - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getActivityTypesResponse({accessToken:usedAccessToken});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getActivityTypes - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_ACTIVITY_TYPE[] = await response.json();
  logger.debug('ApiServices - getActivityTypes - ok, returned body',body);
  return body;
};


interface I_CREATE_ACTIVITY_TYPE_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  name: string,
  description: string,
  import_rule? :string,
  parent: number,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Crée un type d'activité
 * @param param0
 * @returns
 */
const create = async ({accessToken,refreshToken,name,description,import_rule,parent,dispatch,state}:I_CREATE_ACTIVITY_TYPE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createActivityType - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (!description) {
    description = '';
  }
  if (
    !name || name === null || name.trim() === '' ||
    description === undefined || description === null || // description pas obligatoire
    parent === undefined || parent === null) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing name or parentID',
      errorMessage: 'Missing name or parentID to post activity type',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postActivityTypeResponse({accessToken:usedAccessToken,name,import_rule,description,parent});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createActivityType - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createActivityType - ok, returned body',body);
  logger.info(...formatInfo('Activity type created!'));
  return body;
};

/**
 * Supprime un type d'activité
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - deleteActivityType - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteActivityTypeResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteActivityType - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteActivityType - ok, returned body',body);
  logger.info(...formatInfo('Activity type deleted!'));
  return body;
};

interface I_PUT_ACTIVITY_TYPE_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  id: number,
  name: string,
  description: string,
  parent: number;
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Met à jour un type d'activité
 * @param param0
 * @returns
 */
const update = async ({accessToken,refreshToken,id,name,description,parent,dispatch,state}:I_PUT_ACTIVITY_TYPE_PARAMS):Promise<string> => {
  const logger = LoggerService.getInstance();
  logger.debug('ApiServices - updateActivityType - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    id === undefined || id === null ||
    !name || name === null || name.trim() === '' ||
    description === undefined || description === null) { // description pas obligatoire)
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing id, name, description or parentID',
      errorMessage: 'Missing id, name, description or parentID to put activity type',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putActivityTypeResponse({accessToken:usedAccessToken,id,name,description,parent});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateActivityType - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateActivityType - ok, returned body',body);
  logger.info(...formatInfo('Activity type updated!'));
  return body;
};


const activityTypesServices = {
  getList,
  create,
  remove,
  update,
};

export default activityTypesServices;
